<template>
  <div
    class="h-24 bg-zt-primary-100 flex items-center justify-center"
    :style="[footerStyles.bgFooter]"
  >
    <div class="w-full flex items-center justify-center">
      <div
        class="flex items-center justify-center text-zt-white p-3"
        :style="[footerStyles.textColor]"
      >
        <a class="text-white flex items-center mr-2" href="https://sichern.com.ar/" target="_blank">
          <img 
            src="/e/assets/media/favicon-white.png" 
            alt="favicon sichern blanco" 
            class="h-6 w-6" 
            style="filter: brightness(0) invert(1);"
            onerror="this.src='/e/favicon32x32.png'; this.style.filter='brightness(0) invert(1)';" 
          />
        </a>
        <span class="text-white">
          Sichern {{ this.getCurrentYear() }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import VersionSICHERN from '!raw-loader!../../../../../config/version.txt'
export default {
  name: 'ztAuthFooter',
  props: {
    footerStyles: {
      default: () => {},
      type: Object
    }
  },
  methods: {
    getCurrentYear() {
      let d = new Date()
      return d.getFullYear()
    },
    getVersion() {
      return VersionSICHERN.trim()
    }
  }
}
</script>

<style scoped lang="scss">
.text-current {
  color: currentColor;
}
</style>
